module.exports = __webpack_public_path__ + "static/our-mission-2.6278dad8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/our-mission-2.jpg
// module id = 523
// module chunks = 217130003604362